<template>
  <div id="app">
    <img alt="TVL logo" class="logo" src="./assets/logo.png">
    <br>
    <div style="content-align:center;" id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/docs">Documentation</router-link> |
      <router-link to="/api">API</router-link> |
      <a href="https://github.com/archanpatkar/tvl">Github</a>
    </div>
    <div v-bind:style="{paddingRight:padding, paddingLeft:padding}">
      <vue-page-transition name="fade">
        <router-view/>
      </vue-page-transition>
    </div>
    <br>
    <footer><p> &copy; {{new Date().getFullYear()}}  - <a href="https://archan.io">Archan Patkar</a> </p></footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      padding: ""
    };
  },
  mounted() {
    if (/mobile|android|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
      this.padding = "1em";
    }
    else {
      this.padding = "10em";
    } 
  }
}
</script>>

<style>
.logo {
  width:18em;
  height:18em;
}

/* .home {
  margin-left:10em;
  margin-right:10em;
} */


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/* #nav {
  padding-left: 30em;
  padding-right: 30em;
} */

#nav a {
  text-decoration: none;
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #AD0A30;
}
</style>
